import { BoxPaywall } from './box-paywall'
import { useQueryDataDebug } from './hooks/use-query-data-debug'

/**
 * @see {@link useQueryDataDebug} to change the query data.
 */
export function BoxPaywallDebug(...params: Parameters<typeof BoxPaywall>) {
  const [props] = params
  useQueryDataDebug(props)
  return <BoxPaywall {...props} />
}

BoxPaywallDebug.fragments = BoxPaywall.fragments
